import { RootState } from 'store'
import { entityAdapter } from './reducer'

export const { selectAll: selectAllCarrierProducts, selectById: selectCarrierProductById } =
  entityAdapter.getSelectors((state: RootState) => state.carrierProducts)
